<template>
    <div>
        <v-card-title class="justify-center text-h5">
            Lorem
        </v-card-title>
        <v-flex class="d-flex mb-8">
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn class="white--text" color="primary my-2 ml-2">
                <v-icon left class="mr-4">
                    mdi-sync
                </v-icon> Sync
            </v-btn>
        </v-flex>
        <div class="body-1 mb-2">Filter by:</div>
        <div class="d-flex">
            <v-card-text class="col-4 pa-0 mr-4">
                <v-range-slider v-model="range" :max="max" :min="min" hide-details
                    class="align-center ma-0 remove-margins">
                    <template v-slot:prepend>
                        <v-text-field label="Starting Price" outlined dense :value="range[0]" class="mt-0 pt-0 "
                            hide-details type="number" style="width: 120px" @change="$set(range, 0, $event)" suffix="€">
                        </v-text-field>
                    </template>
                    <template v-slot:append>
                        <v-text-field label="Ending Price" outlined dense :value="range[1]" class="mt-0 pt-0 "
                            hide-details type="number" style="width: 120px" @change="$set(range, 1, $event)" suffix="€">
                        </v-text-field>
                    </template>
                </v-range-slider>
            </v-card-text>
            <v-col cols="4" class="pa-0 mr-4">
                <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                    offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field outlined dense v-model="dateRangeText" label="Date Range" readonly v-bind="attrs"
                            v-on="on">
                        </v-text-field>
                    </template>
                    <v-date-picker :locale="$i18n.locale" color="primary" v-model="dates" range></v-date-picker>
                </v-menu>
            </v-col>
            <!-- <v-menu class="col-5" v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="date" label="Picker without buttons" prepend-icon="event" readonly
                        v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
            </v-menu> -->
            <v-autocomplete class="col-3 mr-4" dense outlined v-model="selectedCity" :items="cities" label="City"
                clearable>
            </v-autocomplete>
            <v-btn class="ml-auto" color="primary" depressed fab small dark>
                <v-icon @click="filter()">mdi-filter</v-icon>
            </v-btn>
        </div>
        <v-data-table :headers="companies.headers" :items="companies.values" :loading="loading" :loading-text="$t('tableLoadingLabel')">
            <template #item.actions="{ item }">
                <v-btn class="ml-4 primary--text" small outlined :to="'/dashboard/sales-partner-company/'+ item.id">
                    Manage
                </v-btn>
            </template>
            <template v-slot:no-data>
                {{$t('noDataAvailable')}}
            </template>
            <template v-slot:no-results>
                {{$t('noDataAvailable')}}
            </template>
        </v-data-table>
    </div>
</template>
<script>
    export default {
        name: "CompaniesTable",
        data() {
            return {
                companies: {
                    search: '',
                    headers: [{
                            text: 'Company Nr',
                            value: 'companyNr',
                        },
                        {
                            text: 'Name',
                            value: 'name',
                        },
                        {
                            text: 'Country Code',
                            value: 'countryCode',
                        },
                        {
                            text: 'City',
                            value: 'city',
                        },
                        {
                            text: '',
                            sortable: false,
                            value: 'actions',
                            align: 'end'
                        },
                    ],
                    values: [{
                            companyNr: '123123',
                            name: 'Test',
                            countryCode: '123',
                            city: 'Peje',
                        },
                        {
                            companyNr: '12312243',
                            name: 'Test2',
                            countryCode: '123123',
                            city: 'Prishtine',
                        },
                        {
                            companyNr: '1231234',
                            name: 'Test3',
                            countryCode: '12324',
                            city: 'Prizren',
                        },
                        {
                            companyNr: '1231234',
                            name: 'Test21',
                            countryCode: '12324',
                            city: 'Prizren',
                        }
                    ],
                }
            }
        },
        props: {

        },
        methods: {
            getFilterData() {
                for (let i = 0; i < this.companies.values.length; i++) {
                    this.cities.push(this.companies.values[i].city);
                }
            },
            filter() {
                this.loading = true
                const data = {
                    getByCompany: false,
                    getByUser: false,
                    startPrice: this.range[0],
                    endPrice: this.range[1],
                    startDate: this.dates[0],
                    endDate: this.dates[1],
                }
                this.axios.get('/api/filterOrders/', {
                    params: data
                })
                .then(response => {
                    console.log(response.data);
                    this.loading = false
                })
                .catch(error => {
                    const snackbar = {
                        show: true,
                        message: error.message
                    }
                    this.$EventBus.$emit('snackbar', snackbar)
                    this.loading = false
                })
                // bool getByCompany, bool getByUser,
                // int? companyId, int? userId, 
                // decimal? startPrice, decimal? endPrice, 
                // DateTime? startDate, DateTime? endDate
            }
            // filter() {
            //     const data = {
            //         name: this.filterName ? this.filterName : '',
            //         countryId: this.selectedCountryId,
            //         subjectId: this.selectedTeachingSubjectId,
            //         sortByRating: this.sortByRating,
            //         educationLevelId: this.selectedLevelId
            //     }
            //     this.hideSubjects = this.selectedTeachingSubjectId != null ? true : false
            //     this.axios.get('/Tutor/GetTutorList', { params: data })
            //     .then(response => {
            //         this.tutors = response.data.tutors
            //         this.loading = false
            //     })
            //     .catch(error => {
            //         const snackbar = {
            //             show: true,
            //             message: error.message
            //         }
            //         this.$EventBus.$emit('snackbar', snackbar)
            //         this.loading = false
            //     })
            // },


        },
        watch: {

        },
        mounted() {
            this.getFilterData();
        },
        computed: {
            dateRangeText() {
                return this.dates.join(' ~ ')
            },
        },
    }
</script>
<style lang="scss">
</style>